import {match} from 'ts-pattern';

import {ConsentResponseBody, ConsentStatus, ConsentSubject} from '@dms/api/shared';

export type ContactPersonConsentStatus = 'agreed' | 'refused' | 'none';

const DEALER_SUBJECTS = [ConsentSubject.TENANT, ConsentSubject.BRANCH];
const REFUSED_STATUSES = [ConsentStatus.REJECTED, ConsentStatus.WITHDRAWN];

/**
 * Only dealer consents given by the contact person count. Third-party consents and consents given
 * without a contact person never change the status.
 */
export const getContactPersonConsentStatus = (
  consents: ConsentResponseBody[],
  contactPersonId: string
): ContactPersonConsentStatus => {
  const statuses = consents
    .filter(
      (consent) =>
        consent.contactPersonId === contactPersonId && DEALER_SUBJECTS.includes(consent.subject)
    )
    .map((consent) => consent.status);

  return match(statuses)
    .when(
      (dealerStatuses) => dealerStatuses.includes(ConsentStatus.AGREED),
      (): ContactPersonConsentStatus => 'agreed'
    )
    .when(
      (dealerStatuses) => dealerStatuses.some((status) => REFUSED_STATUSES.includes(status)),
      (): ContactPersonConsentStatus => 'refused'
    )
    .otherwise((): ContactPersonConsentStatus => 'none');
};
